import { render, staticRenderFns } from "./HandbookUpdate.vue?vue&type=template&id=224d62a4&"
import script from "./HandbookUpdate.vue?vue&type=script&lang=js&"
export * from "./HandbookUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports